import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cat_folder",
  "use": "icon-cat_folder-usage",
  "viewBox": "0 0 11.47 10.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.47 10.3\" id=\"icon-cat_folder\"><title>Folder</title><g id=\"icon-cat_folder_图层_2\" data-name=\"图层 2\"><g id=\"icon-cat_folder_图层_1-2\" data-name=\"图层 1\"><path d=\"M11.47,1.65A.48.48,0,0,0,11,1.17H5.93L4.77,0H.48A.49.49,0,0,0,0,.48V9.82a.49.49,0,0,0,.48.48H11a.49.49,0,0,0,.49-.48Zm-1,7.68H1V1h3.4L5.53,2.13h5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol